import React, { useState, useEffect, useContext } from "react";
import { Stepper, Step, StepLabel, Button, Box, Typography } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import Step1AppDetails from "./Step1AppDetails";
import Step2EntityBuilder from "./Step2EntityBuilder";
import Step3IntegrationInstructions from "./Step3IntegrationInstructions";
import { createApp, getAppById, updateAppById } from "../../api";
import { GlobalContext } from "../../GlobalProvider";
const steps = ["App Details", "Create Entities", "Integration Instructions"];

const CreateNewApp = () => {
    const { orgDetails } = useContext(GlobalContext); // Get currentApp from GlobalProvider
    const { appId } = useParams(); // Get appId from URL params
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [appDetails, setAppDetails] = useState({ name: "", description: "" });
    const [entities, setEntities] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);

    useEffect(() => {
        const fetchAppDetails = async () => {
            if (appId) {
                try {
                    const response = await getAppById(appId);
                    const { name, description, entities, geobased, geolocation,overtureds } = response.data.app;
                    setAppDetails({ name, description, geobased, geolocation,overtureds });
                    setEntities(entities || []);
                    setIsEditMode(true);
                } catch (error) {
                    console.error("Error fetching app details:", error);
                }
            }
        };

        fetchAppDetails();
    }, [appId]);

    const handleNext = () => {
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => {
        if( activeStep === 0){
            navigate("/apps");
        }else{
            setActiveStep((prevStep) => prevStep - 1);
        }
    };

    const handleSave = async () => {
        // Prepare the full app details with proper keys (sensorIds and detectionIds)
        const fullAppDetails = {
            ...appDetails,
            organization : orgDetails.id,
            entities: entities.map(entity => ({
                ...entity,
                sensorIds: entity.sensors.map(sensor => sensor._id), // Send as sensorIds
                actionIds: entity.actions.map(action => action._id), // Send as detectionIds
              
                sensors: undefined, // Remove 'sensors' if backend doesn't need it
                actions: undefined, // Remove 'detections' if backend doesn't need it
            })),
        };
    
        try {
            if (isEditMode) {
                // Update existing app if in edit mode
                await updateAppById(appId, fullAppDetails);
                console.log("App updated successfully");
            } else {
                // Create a new app otherwise
                const response = await createApp(fullAppDetails);
                console.log("App created successfully:", response.data);
            }
            navigate("/apps");
        } catch (error) {
            console.error("Error saving app:", error);
        }
    };
    

    const handleReset = () => {
        setActiveStep(0);
        setAppDetails({ name: "", description: "" });
        setEntities([]);
    };

    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                mt: 4,
            }}
        >
            <Box sx={{ maxWidth: 1000, width: "100%" }}>
                <Stepper activeStep={activeStep}>
                    {steps.map((label, index) => (
                        <Step key={index}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Box sx={{ mt: 3 }}>
                    {activeStep === 0 && (
                        <Step1AppDetails appDetails={appDetails} setAppDetails={setAppDetails} />
                    )}
                    {activeStep === 1 && (
                        <Step2EntityBuilder entities={entities} setEntities={setEntities} />
                    )}
                    {activeStep === 2 && <Step3IntegrationInstructions entities={entities} />}
                    <Box sx={{ mt: 2, textAlign: "center" }}>
                     
                            <Button onClick={handleBack} sx={{ mr: 2 }}>
                                Back
                            </Button>
                      
                        {activeStep < steps.length - 1 && (
                            <Button variant="contained" onClick={handleNext}>
                                Next
                            </Button>
                        )}
                        {activeStep === steps.length - 1 && (
                            <Button variant="contained" color="primary" onClick={handleSave}>
                                {isEditMode ? "Update" : "Save"}
                            </Button>
                        )}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default CreateNewApp;
